<div class="btn-bar">
  @if (selectedDate || selectedBooking || selectedSlot) {
    <button
      class="btn btn-outline-secondary"
      translate="common.close"
      (click)="this.closeForm.emit()">
    </button>
  }

</div>

@if (selectedDate || selectedBooking || selectedSlot) {
  <div>
    @if (!selectedBooking) {
      <h3 translate="bookings.add"></h3>
    } @else {
      <h3 translate="bookings.edit"></h3>
    }
    <div [formGroup]="bookingForm">
      <div class="row">
        @if (bookingServiceConfig.bookingMode === BookingMode.Slots) {
          <legend>
            @if (!selectedSlot) {
              <small class="text-danger" translate="bookings.selectedSlot.none"></small>
            } @else {
              <small class="font-weight-bold"
                       [translateParams]="{
                            date: this.selectedSlot.date | date : DateUtils.dateFormat,
                            startTime: DateUtils.formatTime(this.selectedSlot.startTime),
                            endTime: DateUtils.formatTime(this.selectedSlot.endTime)
                       }" translate="bookings.selectedSlot.date">
              </small>
            }
          </legend>
        }
        <!-- Booking/Blocking Chooser -->
        @if (isExploitant && bookingServiceConfig.bookingMode !== BookingMode.Slots) {
          <div class="row">
            <div class="col-12">
              <div>
                <div class="btn-group" role="group">
                  <input class="btn-check" type="radio"
                    [formControl]="reservationType"
                    [value]="ReservationType.Booking">
                    <label class="btn btn-toggle btn-toggle-left h-auto"
                      [ngClass]="{ active: reservationType.value === ReservationType.Booking }"
                      translate="common.reservationType.Booking"
                      (click)="setReservationType(ReservationType.Booking)"
                    (keyup)="setReservationType(ReservationType.Booking)"></label>
                    <input class="btn-check" type="radio"
                      [formControl]="reservationType"
                      [value]="ReservationType.Blocking">
                      <label class="btn btn-toggle btn-toggle-right h-auto"
                        [ngClass]="{ active: reservationType.value === ReservationType.Blocking }"
                        translate="common.reservationType.Blocking"
                        (click)="setReservationType(ReservationType.Blocking)"
                      (keyup)="setReservationType(ReservationType.Blocking)"></label>
                    </div>
                  </div>
                  <app-form-error [control]="debtorType"></app-form-error>
                </div>
              </div>
            }
            <!-- Questions / Answers -->
            <app-item-with-questions-answers-form #itemWithAnswersFormComponent
              [availableItems]="availableItems"
              [reservationType]="reservationType.value"
              [disableItemToBook]="bookingServiceConfig.bookingMode === BookingMode.Slots"
              [selectedItemId]="selectedSlot?.itemToBookId ?? selectedBooking?.itemToBook.id ?? selectedItemId"
              [itemWithAnswerForm]="itemWithAnswerForm"
              [answers]="selectedBooking?.answers"
            [crtLang]="crtLang"></app-item-with-questions-answers-form>
            <!-- Dates / Times -->
            <div class="col-12"
              [ngClass]="{ 'd-none' : bookingServiceConfig.bookingMode === BookingMode.Slots }">
              <app-date-time-period-picker #dateTimeFormComponent
                [dateTimeForm]="dateRangeForm"
                [baseStartDate]="baseStartDate"
                [canStartInPast]="!!selectedBooking && isRecurrent.value"
                [baseStartTime]="baseStartTime"
                [baseEndDate]="baseEndDate"
                [baseEndTime]="baseEndTime"
                [bookingDuration]="bookingServiceConfig.initialBookingDuration"
                [bookingTimeUnit]="bookingServiceConfig.bookingTimeUnit"
                [disableStartTime]="false"
                [disableEndDateTime]="false"
                [minStartDate]="minStartDate"
              [maxStartDate]="maxStartDate"></app-date-time-period-picker>
            </div>
            <!-- Recurrence -->
            @if (this.bookingServiceConfig.bookingMode === BookingMode.Free &&
              (this.isExploitant || this.bookingServiceConfig.recurrentBookingAvailable)) {
              <div class="col-12">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" name="recurrent-checkbox" id="recurrent-checkbox"
                    [formControl]="isRecurrent"
                    (change)="setIsRecurrent(isRecurrent.value)">
                    <label class="form-check-label" for="recurrent-checkbox" translate="bookings.modal.isRecurrent"></label>
                  </div>
                </div>
              }
              <!-- Days -->
              @if (isRecurrent.value) {
                <app-days-picker #recurrentDaysPicker
                  [form]="bookingForm"
                  [initialDays]="recurrenceDays"
                [defaultActivation]="true"></app-days-picker>
              }
              <!-- User or Visitor selector -->
              @if (reservationType.value === ReservationType.Booking) {
                <app-customer-visitor-selector #customerVisitorSelectorComponent
                  [visitor]="selectedBooking?.visitorContact"
                  [customer]="selectedBooking?.customerContact"
                  [customerId]="selectedBooking?.customerId || this.customerId"
                  [isExploitant]="isExploitant"
                  [debtorType]="debtorType"
                  [customerIdControl]="customerIdControl"
                  [visitorContactForm]="visitorContactForm"
                (debtorTypeChange)="configurePaymentTypes()"></app-customer-visitor-selector>
              }
              <!-- Comment -->
              <div class="col-12">
                <label class="form-label">{{ 'bookings.modal.user.comment' | translate }}</label>
                <textarea class="form-control" id="comment" name="bookingComment"
                  [formControl]="comment"
                  placeholder="{{'bookings.modal.user.comment' | translate}}"
                maxlength="255"></textarea>
                <app-form-error [control]="comment"></app-form-error>
              </div>
              <!-- Payment Types-->
              @if (paymentType.enabled && availablePaymentTypes.length > 1) {
                <div class="col-12">
                  <label class="form-label">{{ 'common.terms.paymentType' | translate }}*</label>
                  <div>
                    <app-payment-type-chooser
                      [availablePaymentTypes]="availablePaymentTypes"
                    (selectedPaymentType)="selectPaymentType($event)"></app-payment-type-chooser>
                  </div>
                </div>
              }
              @if (paymentType.enabled) {
                <app-show-cgv
                  [formGroup]="bookingForm">
                </app-show-cgv>
              }
            </div>
            <div class="btn-bar">
              <button class="btn btn-primary" type="submit"
                [disabled]="bookingForm.invalid || bookingForm.pristine"
                (click)="openSaveBookingConfirmModal()"
                translate="common.save">
              </button>
            </div>
          </div>
        </div>
      }
